import Vue from 'vue'
import axios from 'axios'
import lodash from 'lodash'
import store from './storage.js'
import App from '../app.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'flexbox-set/src/index.css'
import './application.scss'
import ActionCableVue from 'actioncable-vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

Vue.use(BootstrapVue)
const fallbackCableUrl = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/cable`
let cableUrl = window.gon.region.action_cable_url || fallbackCableUrl
// ws://localhost из региона имеет смысл только если страница сама открыта с localhost
if (/^wss?:\/\/(localhost|127\.0\.0\.1)(:|\/)/.test(cableUrl) &&
    !/(^|\.)localhost$|^127(\.\d+){3}$/.test(window.location.hostname)) {
    cableUrl = fallbackCableUrl
}

Vue.use(ActionCableVue, {
    debug: true,
    debugLevel: 'error',
    connectionUrl: cableUrl,
    connectImmediately: true,
})

const requireComponent = import.meta.glob('../components/descriptions/*.vue', { eager: true })

Object.entries(requireComponent).forEach(([fileName, componentConfig]) => {
    const componentName = upperFirst(
        camelCase(
        fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')
        )
    )
    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash });
Object.defineProperty(Vue.prototype, '$http', { value: axios });

document.addEventListener('DOMContentLoaded', () => {
    let meta = document.querySelector("meta[name='csrf-token']");
    meta ? Vue.prototype.$http.defaults.headers.common['X-CSRF-TOKEN'] = meta.getAttribute('content') : false;
    new Vue({
        el: '#app',
        store,
        render: h => h(App)
    })
});